import useMetasearchDiscount from 'hooks/useMetasearchDiscount'
import useGhaVerifierPrice from 'hooks/useGhaVerifierPrice'
import { getDiscountedPropertyCashPrice } from './propertyCashPrices'

export default function usePropertyStickyCashPrices(
  cheapestHotelOnlyRate: App.EnrichedPropertyRate | App.Property.AnytimeRate | undefined,
  cheapestHotelOnlyDiscountRate: App.EnrichedPropertyRate | undefined,
  checkIn: string | undefined,
  checkOut: string | undefined,
  rooms: Array<App.Occupants>,
) {
  const hotelPrice = cheapestHotelOnlyRate?.totals.displayPrice ?? 0
  const memberPrice = cheapestHotelOnlyRate?.luxPlusTotals?.displayPrice ?? 0
  const isBedbankRate = cheapestHotelOnlyRate && 'service' in cheapestHotelOnlyRate && cheapestHotelOnlyRate.service.type === 'bedbank'
  // Match the anchored property AND rate, not just price: another rate can have the same price.
  const shouldApplyDiscount = isBedbankRate &&
    cheapestHotelOnlyDiscountRate &&
    cheapestHotelOnlyDiscountRate.service.propertyId === cheapestHotelOnlyRate.service.propertyId &&
    cheapestHotelOnlyDiscountRate.rateId === cheapestHotelOnlyRate.rateId
  const [discountAmount, discountFetching] = useMetasearchDiscount(hotelPrice, {
    propertyId: isBedbankRate ? cheapestHotelOnlyRate.service.propertyId : undefined,
    checkIn,
    checkOut,
    rooms,
    disabled: !shouldApplyDiscount,
  })
  const displayHotelPrice = useGhaVerifierPrice(getDiscountedPropertyCashPrice(hotelPrice, discountAmount), !shouldApplyDiscount)
  // Sticky prices use zero as their absent-member sentinel; rate tiles use undefined.
  const displayMemberPrice = memberPrice ? getDiscountedPropertyCashPrice(memberPrice, discountAmount) : memberPrice
  const showMemberPrice = !!displayMemberPrice && displayMemberPrice < displayHotelPrice
  return { hotelPrice, displayHotelPrice, displayMemberPrice, showMemberPrice, discountFetching }
}
